/**
 * @module ProductOverlays
 */
import { Overlay } from 'ol';

/**
 * classdesc
 * ProductOverlays is a class that manages the overlays for a product.
 */

class ProductOverlays {
  /**
   * Create an overlay manager.
   * @param {object} map 
   */
  constructor(map) {
    this.map = map;
  }

  /**
   * Add overlays to the map.
   * @param {object} overlaysConfig 
   */
  addOverlays(overlaysConfig) {
    overlaysConfig.forEach(overlayConfig => {
      let overlay;
      // NOTE: the popup overlay have been moved to their own class. 
      // This is for additional overlays that might be needed.
      overlay = new Overlay({
        element: document.getElementById(overlayConfig.elementId),
        autoPan: overlayConfig.autoPan,
        autoPanAnimation: {
          duration: overlayConfig.autoPanAnimationDuration,
        },
      });
      this.map.addOverlay(overlay);
    });
  }

  /**
   * Remove overlays from the map.
   * @param {object} overlaysConfig 
   */
  removeOverlays(overlaysConfig) {
    overlaysConfig.forEach(overlayConfig => {
      const overlay = this.map.getOverlayById(overlayConfig.elementId);
      if (overlay) {
        this.map.removeOverlay(overlay);
      }
    });
  }
}

export default ProductOverlays;